







































import { computed, defineComponent, getCurrentInstance, nextTick, PropType, ref, watch } from 'vue';
import { InstitutionProfileModel } from '../../../shared/models/institutionProfile.model';
import { useEsdhExport } from '../../composables/documents/useEsdhExport';
import { SecureDocumentModel } from '../../../shared/models/secureDocument.model';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';

export default defineComponent({
  name: 'DocumentEsdhExportChild',
  components: { Icon },
  props: {
    child: { type: Object as PropType<InstitutionProfileModel>, required: true },
    document: { type: Object as PropType<SecureDocumentModel>, required: true },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const { selectedDocuments, caseNumberErrors, toggleChild, updateCaseReference, validateCaseReference } =
      useEsdhExport();
    const caseReferenceInputRef = ref(null);
    const isExpanded = ref(false);
    const isSelected = computed({
      get() {
        return selectedDocuments[props.document.id]?.children[props.child.id]?.selected ?? false;
      },
      set(value: boolean) {
        toggleChild(props.document.id, props.child.id, value);
      },
    });
    const caseReference = computed({
      get() {
        return selectedDocuments[props.document.id]?.children[props.child.id]?.caseReference ?? '';
      },
      set(value: string) {
        updateCaseReference(props.document.id, props.child.id, value);
      },
    });
    const isDisabled = computed(() => {
      const document = selectedDocuments[props.document.id];
      if (!document) {
        return false;
      }
      const selectedChildren = Object.values(document.children).filter(child => child.selected);
      return selectedChildren.length === 1 && selectedChildren[0].childId === props.child.id;
    });
    const tooltip = computed(() => {
      if (isDisabled.value) {
        return proxy.$t('document.one_child_selected_warning');
      }
      return `${props.child.name} (${props.child.metadata})`;
    });

    const expandCaseNumber = async () => {
      isExpanded.value = true;
      caseReference.value = '';
      await nextTick();
      caseReferenceInputRef.value.focus();
    };

    const collapseCaseNumber = () => {
      isExpanded.value = false;
      caseReference.value = null;
      validateCaseReference(props.document.id, props.child.id);
    };

    watch(caseNumberErrors, errors => {
      if (errors[props.document.id]?.[props.child.id]) {
        emit('error');
      }
    });

    return {
      iconClassEnum,
      isSelected,
      caseReference,
      selectedDocuments,
      isExpanded,
      caseNumberErrors,
      isDisabled,
      tooltip,
      caseReferenceInputRef,
      expandCaseNumber,
      collapseCaseNumber,
      validateCaseReference,
    };
  },
});
